<template>
  <DialogClose @click="handleClick">
    <slot name="start" />
    <slot />
  </DialogClose>
</template>

<script setup>
import { DialogClose } from "radix-vue";

const emit = defineEmits(["click"]);

function handleClick(event) {
  setTimeout(emit("click", event), 100);
}
</script>
